<script lang="ts">
	import { matchLocation, type GeolocationBlockFields } from '$lib/utils/geolocation';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '../editable';
	import Blok from '../blok.svelte';
	import { geolocation } from '$lib/state/geolocation.svelte';
	import { storyblok } from '$lib/state/storyblok.svelte';
	interface Props {
		content: ISbStoryData<GeolocationBlockFields>['content'];
	}

	let { content }: Props = $props();

	let visibleBlocks = $derived(
		matchLocation(content, geolocation.data) ||
			(content.force_match_in_editor && storyblok.editMode)
			? content.match_blocks
			: content.original_blocks
	);
</script>

<div
	use:editable={content}
	class={['empty:hidden', { contents: !storyblok.editMode, 'relative block': storyblok.editMode }]}
>
	{#each visibleBlocks as block}
		<Blok content={block} />
	{/each}

	{#if storyblok.editMode}
		<div
			class="absolute right-2 top-2 z-[100] select-none rounded-full bg-yellow-5 px-2 py-1 text-sm font-semibold text-brown-1 hover:opacity-10"
			class:line-through={content.force_match_in_editor}
		>
			City: <strong>{decodeURIComponent(geolocation.data.city)}</strong> / Region:
			<strong>{decodeURIComponent(geolocation.data.region)}</strong>
		</div>
	{/if}
</div>
